import axios from "axios";
import React, { useState } from "react";
import {Link} from 'react-router-dom';
import { useSettings } from '../SettingsContext';
import {toast} from "react-toastify";

const Contact = () => {
    const setting = useSettings();
    const [formData, setFormData] = useState({
        name: '',
        phone: '',
        subject: '',
        message: '',
        honeypot: '',
        timestamp: Date.now()
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (formData.honeypot) {
            toast.error('Please send message later.');
            return;
        }
        const submissionTime = Date.now();
        const timeDiff = submissionTime - formData.timestamp;

        if (timeDiff < 3000) {
            toast.error('Please send message later.');
            return;
        }
        try {
            const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
            const Url = process.env.REACT_APP_API_CONTACT_MESSAGE_STORE;
            const response = await axios.post(`${apiBaseUrl}${Url}`, formData);

            if (response.status === 200) {
                toast.success('Message sent successfully!');
                setFormData({ name: '', phone: '', subject: '', message: '' , honeypot: '' , timestamp: Date.now() });
            } else {
                toast.error('Something went wrong. Try again.');
            }
        } catch (error) {
            toast.error('Failed to send message.');
        }
    };
    return (
        <main className="main">
            <div className="site-breadcrumb" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/assets/img/breadcrumb/01.jpg)`}}>
                <div className="container">
                    <h2 className="breadcrumb-title"> আমাদের সাথে যোগাযোগ করুন </h2>
                    <ul className="breadcrumb-menu">
                        <li>
                            <Link to={'/'} className="nav-link">হোম</Link>
                        </li>
                        <li className="active"> আমাদের সাথে যোগাযোগ করুন </li>
                    </ul>
                </div>
            </div>
            {/* contact area */}
            <div className="contact-area py-100">
                <div className="container">
                    <div className="contact-content">
                        <div className="row">
                            <div className="col-12 col-xl-3">
                                <div className="contact-info">
                                    <div className="icon">
                                        <i className="fal fa-map-location-dot"></i>
                                    </div>
                                    <div className="content">
                                        <h5>Office Address</h5>
                                        <p>{setting?.address}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-xl-3">
                                <div className="contact-info">
                                    <div className="icon">
                                        <i className="fal fa-phone-volume"></i>
                                    </div>
                                    <div className="content">
                                        <h5>Call Us</h5>
                                        <p>{setting?.footer_phone || ''}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-xl-3">
                                <div className="contact-info">
                                    <div className="icon">
                                        <i className="fal fa-envelopes"></i>
                                    </div>
                                    <div className="content">
                                        <h5>Email Us</h5>
                                        <p>
                                            <a href={`mailto:${setting?.email || ''}`}>
                                                <span className="__cf_email__">{setting?.email || ''}</span>
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-xl-3">
                                <div className="contact-info">
                                    <div className="icon">
                                        <i className="fal fa-alarm-clock"></i>
                                    </div>
                                    <div className="content">
                                        <h5>Open Time</h5>
                                        <p>{setting?.office_hour || ''}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="contact-form-wrap">
                        <div className="row g-4">
                            <div className="col-lg-7">
                                <div className="contact-form">
                                    <div className="contact-form-header">
                                        <h2>আপনার কোনো তথ্য জানার আছে?</h2>
                                    </div>
                                    <form onSubmit={handleSubmit}>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <div className="form-icon">
                                                        <i className="far fa-user-tie"></i>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name="name"
                                                            placeholder="আপনার নাম লিখুন"
                                                            value={formData.name}
                                                            onChange={handleChange}
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <div className="form-icon">
                                                        <i className="far fa-phone"></i>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name="phone"
                                                            placeholder="আপনার ফোন নাম্বার লিখুন"
                                                            value={formData.phone}
                                                            onChange={handleChange}
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className="form-icon">
                                                <i className="far fa-pen"></i>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="subject"
                                                    placeholder="আপনার বিষয় লিখুন"
                                                    value={formData.subject}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className="form-icon">
                                                <i className="far fa-comment-lines"></i>
                                                <textarea
                                                    name="message"
                                                    className="form-control"
                                                    rows="5"
                                                    placeholder="আপনার মেসেজ লিখুন"
                                                    value={formData.message}
                                                    onChange={handleChange}
                                                    required
                                                ></textarea>
                                            </div>
                                        </div>

                                        {/* Honeypot field - hidden from the user */}
                                        <input
                                            type="hidden"
                                            name="honeypot"
                                            value={formData.honeypot}
                                            onChange={handleChange}
                                        />

                                        <button type="submit" className="theme-btn">
                                            মেসেজ পাঠান <i className="far fa-paper-plane"></i>
                                        </button>
                                    </form>
                                </div>
                            </div>
                            <div className="col-lg-5">
                                <div className="contact-img">
                                    <img src="assets/img/contact/01.jpg" alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* end contact area */}


             {/*map */}
            <div className="contact-map">
                <iframe src={setting?.map} width="600" height="450" allowFullScreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
            </div>
            {/* map end */}

        </main>
    );
}

export default Contact;